import PropTypes from 'prop-types';
import ConsentIcon from '../../../../atoms/icons/consentIcon';

const ActivePvrLiteButton = ({ pvrLite, setFieldValue }) => {
  const handleButtonClick = (e) => {
    e.preventDefault();
    setFieldValue('acceptPvrLite', !pvrLite);
  };

  const text = pvrLite ? '(Opted In)' : '(Opted out)';

  return (
    <div>
      <button onClick={handleButtonClick} className="active-status-button">
        <span>
          PVR Lite Opt In/Out
          <br />
          <b>{text}</b>
        </span>
        <ConsentIcon height="24" width="24" />
      </button>
    </div>
  );
};

ActivePvrLiteButton.propTypes = {
  pvrLite: PropTypes.bool.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default ActivePvrLiteButton;
